import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext, useEffect, useState } from 'react';
import { Invoice } from '@alliance-disposal/transport-types';
import { CustomFormContext } from '../../../formWrapper/SourSearchWrapper';
///////////////////////////////////////////////
// STATUS PILL COMPONENT
///////////////////////////////////////////////
export const InvoiceStatusPill = ({ status }) => {
    const { application } = useContext(CustomFormContext);
    const [label, setLabel] = useState('');
    useEffect(() => {
        if (status === 'NONE') {
            setLabel('None');
            return;
        }
        if (application === 'aap') {
            setLabel(Invoice.InvoiceStatusLabels[status]);
        }
        if (application === 'wayste') {
            setLabel(Invoice.InvoiceStatusLabels[status]);
        }
        // FOR CUSTOMER PORTAL APPLY SPECIAL LABEL AND COLORS
        if (application === 'customer-portal') {
            setLabel(Invoice.InvoiceStatusLabels[status]);
        }
    }, [application, status]);
    /////////////////////////////////////////////
    // RENDER;
    /////////////////////////////////////////////
    switch (status) {
        case 'DRAFT':
            return (_jsx("span", { className: `m-0.5 inline-block overflow-hidden overflow-ellipsis whitespace-nowrap rounded-full px-3 text-xs ${'bg-invoiceStatuses-DRAFT-pill-background text-invoiceStatuses-DRAFT-pill-text outline outline-1'} }`, children: _jsx("div", { children: label }) }));
        // return <Chip label={label} size={'small'} primaryColor={'#Fae'} textColor={'#4E4E66'} />;
        case 'ISSUED':
            return (_jsx("span", { className: `inline-block overflow-hidden overflow-ellipsis whitespace-nowrap rounded-full px-3 py-0.5 text-xs ${'bg-invoiceStatuses-ISSUED-pill-background text-invoiceStatuses-ISSUED-pill-text'} }`, children: label }));
        case 'PAID':
            return (_jsx("span", { className: `inline-block overflow-hidden overflow-ellipsis whitespace-nowrap rounded-full px-3 py-0.5 text-xs ${'bg-invoiceStatuses-PAID-pill-background text-invoiceStatuses-PAID-pill-text'} }`, children: label }));
        case 'VOID':
            return (_jsx("span", { className: `inline-block overflow-hidden overflow-ellipsis whitespace-nowrap rounded-full px-3 py-0.5 text-xs ${'bg-invoiceStatuses-VOID-pill-background text-invoiceStatuses-VOID-pill-text'} }`, children: label }));
        case 'PARTIALLY_PAID':
            return (_jsx("span", { className: `inline-block overflow-hidden overflow-ellipsis whitespace-nowrap rounded-full px-3 py-0.5 text-xs ${'bg-invoiceStatuses-PARTIALLY_PAID-pill-background text-invoiceStatuses-PARTIALLY_PAID-pill-text'} }`, children: label }));
        case 'PARTIALLY_VOID':
            return (_jsx("span", { className: `inline-block overflow-hidden overflow-ellipsis whitespace-nowrap rounded-full px-3 py-0.5 text-xs ${'bg-invoiceStatuses-PARTIALLY_VOID-pill-background text-invoiceStatuses-PARTIALLY_VOID-pill-text'} }`, children: label }));
        case 'PARTIALLY_REFUNDED':
            return (_jsx("span", { className: `inline-block overflow-hidden overflow-ellipsis whitespace-nowrap rounded-full px-3 py-0.5 text-xs ${'bg-invoiceStatuses-PARTIALLY_REFUNDED-pill-background text-invoiceStatuses-PARTIALLY_REFUNDED-pill-text'} }`, children: label }));
        case 'REFUNDED':
            return (_jsx("span", { className: `inline-block overflow-hidden overflow-ellipsis whitespace-nowrap rounded-full px-3 py-0.5 text-xs ${'bg-invoiceStatuses-REFUNDED-pill-background text-invoiceStatuses-REFUNDED-pill-text'} }`, children: label }));
        case 'PAST_DUE':
            return (_jsx("span", { className: `inline-block overflow-hidden overflow-ellipsis whitespace-nowrap rounded-full px-3 py-0.5 text-xs ${'bg-invoiceStatuses-PAST_DUE-pill-background text-invoiceStatuses-PAST_DUE-pill-text'} }`, children: label }));
        case 'NONE':
            return (_jsx("span", { className: `inline-block overflow-hidden overflow-ellipsis whitespace-nowrap rounded-full px-3 py-0.5 text-xs ${'bg-invoiceStatuses-DRAFT-pill-background text-invoiceStatuses-DRAFT-pill-text'} }`, children: label }));
        default:
            return _jsx(_Fragment, {});
    }
};
//# sourceMappingURL=invoiceStatusPills.js.map